const CONST = {
    JACKPOT: {
        PLATINUM: {
            name: 'platinum',
            multiplier: 5000
        },
        GOLD: {
            name: 'gold',
            multiplier: 150
        },
        SILVER: {
            name: 'silver',
            multiplier: 50
        },
        BRONZE: {
            name: 'bronze',
            multiplier: 20
        }
    },
    SYMBOLS: {
        WILD: "2",
        COIN: "0",
        SCATTER: "1",
    },
    COLUMNS: 5,
    ROWS: 4
}

export {CONST}